import {
  CommercialFarming,
  Hotel,
  Industrial,
  LandDevelopment,
  Medical,
  Offices,
  Other,
  Retail,
  Showrooms,
} from './index';
import {
  COMMERCIAL_FARMING,
  HOTEL_LEISURE,
  INDUSTRIAL_WAREHOUSE,
  LAND_DEVELOPMENT,
  MEDICAL_CONSULTING,
  OFFICES,
  OTHER,
  RETAIL,
  SHOWROOMS_BULKY_GOODS,
} from '../../../../shared/model/constants/propertyTypes';

const DEFAULT_ICON = Other;
const propertyTypeIcons = new Map([
  [COMMERCIAL_FARMING, CommercialFarming],
  [HOTEL_LEISURE, Hotel],
  [INDUSTRIAL_WAREHOUSE, Industrial],
  [LAND_DEVELOPMENT, LandDevelopment],
  [MEDICAL_CONSULTING, Medical],
  [OFFICES, Offices],
  [OTHER, Other],
  [RETAIL, Retail],
  [SHOWROOMS_BULKY_GOODS, Showrooms],
]);

export const getIconForPropertyType = propertyTypeObject =>
  propertyTypeIcons.get(propertyTypeObject) || DEFAULT_ICON;
